import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { apolloService } from '../../common/services'

import { DOWNLOAD_MENU_DOCUMENT_MUTATION } from '../graphql/mutations'
import { DOWNLOAD_MENU_DOCUMENT } from '../redux/action-types'

const useDownloadMenuDocumentMutation = () => {
  const dispatch = useDispatch()

  const mutate = useCallback(
    menuId =>
      apolloService.mutate({
        mutation: DOWNLOAD_MENU_DOCUMENT_MUTATION,
        variables: { menuId },
        dispatch,
        action: DOWNLOAD_MENU_DOCUMENT,
      }),
    [dispatch],
  )

  return [mutate]
}

export default useDownloadMenuDocumentMutation
